import React, { useEffect, useMemo, useState } from "react";
import Form from "../../../components/Form";
import ResourceSelectLazyLoading from "../../../components/ResourceSelectLazyLoading";
import Checkbox from "../../../components/Checkbox";

const EmployeeFieldWithCheckbox = ({ form, value, disabled, t }) => {
  const [validContractFilter, setValidContractFilter] = useState(true);
  const [refetchFlag, setRefetchFlag] = useState(false);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const customParamsBase = {
    order_by_column: ["name"],
    order_by_type: ["asc"],
    field: ["user_is_in_organisation"],
    op: ["eq"],
    term: [1]
  };

  const customParams = useMemo(() => {
    return validContractFilter ? { ...customParamsBase, "filters[validContract]": 1 } : customParamsBase;
  }, [customParamsBase, validContractFilter]);

  const setEmployee = (value) => {
    form.setFieldsValue({ user_id: value });
  };

  const toggleFilter = () => {
    setValidContractFilter(!validContractFilter);
    setRefetchFlag(true);
  };

  useEffect(() => {
    if (refetchFlag) {
      setRefetchFlag(false);
    }
  }, [refetchFlag]);

  return (
    <Form.Item required={true} name="user_id" label={t("trg.add_qualification_modal.employee")}>
      <div>
        <ResourceSelectLazyLoading
          refetchOptions={refetchFlag}
          placeholder={t("trg.add_qualification_modal.employee")}
          apiRoute="users/all"
          onChange={setEmployee}
          disabled={disabled}
          value={value}
          transformer={(res) =>
            res.map((user) => ({ ...user, text: `${user.name} (${user.userDetail.staff_number})` }))
          }
          searchColumns={["name"]}
          customParams={customParams}
          style={{ width: "100%" }}
        />
        {!disabled && (
          <div style={{ marginTop: 8 }}>
            <Checkbox
              checked={validContractFilter}
              onChange={toggleFilter}
              disabled={disabled}
              style={{ fontWeight: 100 }}
            >
              {t("trg.add_qualification_modal.only_valid_employee")}
            </Checkbox>
          </div>
        )}
      </div>
    </Form.Item>
  );
};

export default EmployeeFieldWithCheckbox;
